import Axios from 'axios';

const axios = Axios.create({
  // baseURL: process.env.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  responseType: 'json'
});

axios.interceptors.request.use(config => {
  config.headers['Authorization'] = localStorage.getItem('accessToken');
  const envBaseUrl = localStorage.getItem('envBaseUrl') || process.env.BASE_URL;
  config.url = `${envBaseUrl}${config.url}`;
  return config;
});


const suAxios = Axios.create({
  // baseURL: process.env.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  responseType: 'json'
});

suAxios.interceptors.request.use(config => {
  config.headers['Authorization'] = localStorage.getItem('suAccessToken');
  const envBaseUrl = localStorage.getItem('envBaseUrl') || process.env.BASE_URL;
  config.url = `${envBaseUrl}${config.url}`;
  return config;
});

const suMultiEnvAxios = Axios.create({
  // baseURL: process.env.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  responseType: 'json'
});

suMultiEnvAxios.interceptors.request.use(config => {
  config.headers['Authorization'] = localStorage.getItem('suAccessToken');
  return config;
});


export { suAxios, suMultiEnvAxios };
export default axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js